import { Injectable } from '@angular/core';

import { Color } from '../../models';
import { App } from '../../models';
import { FieldStyleColor, MapElementColor, MapPinColor, MapPinColorName, UserSelectablePresetColors, UserSelectablePresetColorsClasses } from '../../shared/enums';
import { ColorsUtilityServiceModel } from './models';

@Injectable({
    providedIn: 'root'
})
export class ColorsUtilityService {
    private _root = document.documentElement;
    model: ColorsUtilityServiceModel = new ColorsUtilityServiceModel();

    constructor() { }

    initModelOnAppSelection(app: App): void {
        this.model = new ColorsUtilityServiceModel();
        this.setAppColorForSelection(app);
        this.makeColorOptionsAvailableViaCss();
    }

    setAppColorForSelection(app: App): void {
        const appColor = app?.mapPinColor?.hex ?? UserSelectablePresetColors.DefaultAppColor;
        this.model.appPresetColors.set(UserSelectablePresetColorsClasses.AppColor, appColor);
        this.model.mapPinColors.set(MapPinColor.AppColor, { name: MapPinColorName.AppColor, color: appColor });
    }

    makeColorOptionsAvailableViaCss(): void {
        this.model.appPresetColors.forEach((colorValue, className) => {
            this.addCssGLobalVariable(`--${className}`, colorValue);
        });
    }

    addCssGLobalVariable(variableName: string, colorValue: string): void {
        this._root.style.setProperty(variableName, colorValue);
    }

    getFieldStyleColorClassByColor(color: FieldStyleColor): string {
        return this.model.fieldStyleColors.get(color).class;
    }

    getHexOfMapPinColor(mapPinColor: MapPinColor): string {
        return this.model.mapPinColors.get(mapPinColor).color;
    }

    getHexOfMapElementColor(mapElementColor: MapElementColor): string {
        return this.model.mapElementColors.get(mapElementColor).color;
    }

    getHexColorFromFieldStyleColorClass(colorClass: string): string {
        return this.model.appPresetColors.get(colorClass);
    }

    hexToColorObject(hexString: string): Color {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
        return result ? new Color(
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16)
        ) : null;
    }
}
